(function () {
  const storageKey = "pure-accessibility-preferences";
  const state = {
    textSmall: false,
    textLarge: false,
    screenSmall: false,
    screenLarge: false,
    fixedDescription: false,
    yellowBlack: false,
    highContrast: false,
    invertColors: false,
    sepia: false,
    underlineLinks: false,
    reduceMotion: false,
    readableFont: false,
    grayscale: false,
    hideImages: false,
    highlightHeadings: false,
    textSpacing: false
  };
  const themeConfig = window.SENO_THEME || {};
  const whatsappHref = themeConfig.whatsappPhone
    ? `https://wa.me/${themeConfig.whatsappPhone}`
    : "#";

  const labels = {
    open: "\u05e4\u05ea\u05d9\u05d7\u05ea \u05d0\u05e4\u05e9\u05e8\u05d5\u05d9\u05d5\u05ea \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    options: "\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    copy: "\u05d4\u05ea\u05d0\u05de\u05d5\u05ea \u05e6\u05e4\u05d9\u05d9\u05d4, \u05e7\u05e8\u05d9\u05d0\u05d4 \u05d5\u05e0\u05d5\u05d7\u05d5\u05ea \u05dc\u05e4\u05d9 \u05d4\u05e6\u05d5\u05e8\u05da \u05e9\u05dc\u05da.",
    close: "\u05e1\u05d2\u05d9\u05e8\u05ea \u05d7\u05dc\u05d5\u05df \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    reset: "\u05d0\u05d9\u05e4\u05d5\u05e1 \u05d4\u05ea\u05d0\u05de\u05d5\u05ea",
    statement: "\u05d4\u05e6\u05d4\u05e8\u05ea \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea",
    report: "\u05d3\u05d9\u05d5\u05d5\u05d7 \u05d4\u05e4\u05e8\u05d4",
    poweredBy: "\u05de\u05d5\u05e4\u05e2\u05dc \u05e2\u05dc \u05d9\u05d3\u05d9",
    on: "\u05e4\u05e2\u05d9\u05dc",
    off: "\u05db\u05d1\u05d5\u05d9",
    whatsappOpen: "\u05e4\u05ea\u05d9\u05d7\u05ea \u05e9\u05d9\u05d7\u05ea \u05d5\u05d5\u05d0\u05d8\u05e1\u05d0\u05e4",
    whatsapp: "\u05d5\u05d5\u05d0\u05d8\u05e1\u05d0\u05e4"
  };

  const options = [
    { key: "grayscale", label: "\u05de\u05d5\u05e0\u05d5\u05db\u05e8\u05d5\u05dd", className: "a11y-grayscale", icon: "\u25cc" },
    { key: "reduceMotion", label: "\u05d1\u05d9\u05d8\u05d5\u05dc \u05d4\u05d1\u05d4\u05d5\u05d1\u05d9\u05dd", className: "a11y-reduce-motion", icon: "\u223f" },
    { key: "hideImages", label: "\u05e1\u05d2\u05d9\u05e8\u05d4", className: "a11y-hide-images", icon: "\u25a3" },
    { key: "yellowBlack", label: "\u05e9\u05d7\u05d5\u05e8 \u05e6\u05d4\u05d5\u05d1", className: "a11y-yellow-black", icon: "\u25e7" },
    { key: "highContrast", label: "\u05e0\u05d9\u05d2\u05d5\u05d3\u05d9\u05d5\u05ea \u05d2\u05d1\u05d5\u05d4\u05d4", className: "a11y-high-contrast", icon: "\u25d0" },
    { key: "sepia", label: "\u05e1\u05e4\u05d9\u05d4", className: "a11y-sepia", icon: "\u25e9" },
    { key: "underlineLinks", label: "\u05d4\u05d3\u05d2\u05e9\u05ea \u05e7\u05d9\u05e9\u05d5\u05e8\u05d9\u05dd", className: "a11y-underline-links", icon: "\u2317" },
    { key: "highlightHeadings", label: "\u05d4\u05d3\u05d2\u05e9\u05ea \u05db\u05d5\u05ea\u05e8\u05d5\u05ea", className: "a11y-highlight-headings", icon: "A" },
    { key: "invertColors", label: "\u05d4\u05d9\u05e4\u05d5\u05da \u05e6\u05d1\u05e2\u05d9\u05dd", className: "a11y-invert-colors", icon: "\u25e8" },
    { key: "textLarge", label: "\u05d4\u05d2\u05d3\u05dc\u05ea \u05d2\u05d5\u05e4\u05df", className: "a11y-text-large", icon: "A+" },
    { key: "readableFont", label: "\u05d2\u05d5\u05e4\u05df \u05e7\u05e8\u05d9\u05d0", className: "a11y-readable-font", icon: "A" },
    { key: "fixedDescription", label: "\u05ea\u05d9\u05d0\u05d5\u05e8 \u05e7\u05d1\u05d5\u05e2", className: "a11y-fixed-description", icon: "\u25ad" },
    { key: "screenSmall", label: "\u05d4\u05e7\u05d8\u05e0\u05ea \u05de\u05e1\u05da", className: "a11y-screen-small", icon: "\u21f2" },
    { key: "screenLarge", label: "\u05d4\u05d2\u05d3\u05dc\u05ea \u05de\u05e1\u05da", className: "a11y-screen-large", icon: "\u21f1" },
    { key: "textSmall", label: "\u05d4\u05e7\u05d8\u05e0\u05ea \u05d2\u05d5\u05e4\u05df", className: "a11y-text-small", icon: "A-" }
  ];

  const loadState = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || "{}");
      options.forEach((option) => {
        state[option.key] = Boolean(saved[option.key]);
      });
    } catch (error) {
      console.error("Failed to load accessibility preferences", error);
    }
  };

  const saveState = () => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(state));
    } catch (error) {
      console.error("Failed to save accessibility preferences", error);
    }
  };

  const applyState = () => {
    options.forEach((option) => {
      document.body.classList.toggle(option.className, state[option.key]);
    });
  };

  const createWidget = () => {
    const fab = document.createElement("button");
    fab.type = "button";
    fab.className = "accessibility-fab";
    fab.setAttribute("aria-label", labels.open);
    fab.setAttribute("aria-expanded", "false");
    fab.setAttribute("aria-controls", "accessibility-panel");
    fab.innerHTML = `
      <span class="accessibility-fab__icon" aria-hidden="true">
        <img src="${themeConfig.assets?.accessibilityFab || ""}" alt="" class="accessibility-fab__image">
      </span>
    `;

    const backdrop = document.createElement("div");
    backdrop.className = "accessibility-backdrop";
    backdrop.hidden = true;

    const panel = document.createElement("section");
    panel.className = "accessibility-panel";
    panel.id = "accessibility-panel";
    panel.hidden = true;
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "false");
    panel.setAttribute("aria-label", labels.options);

    const togglesMarkup = options
      .map(
        (option) => `
          <button class="accessibility-toggle" type="button" data-a11y-toggle="${option.key}">
            <span class="accessibility-toggle__icon" aria-hidden="true">${option.icon}</span>
            <span class="accessibility-toggle__label">${option.label}</span>
            <span class="accessibility-toggle__status">${labels.off}</span>
          </button>
        `
      )
      .join("");

    panel.innerHTML = `
      <div class="accessibility-panel__header">
        <button class="accessibility-panel__close" type="button" aria-label="${labels.close}">
          <span aria-hidden="true">&times;</span>
        </button>
        <div class="accessibility-panel__copy">
          <h2 class="accessibility-panel__title">${labels.options}</h2>
          <p class="accessibility-panel__text">${labels.copy}</p>
        </div>
      </div>
      <div class="accessibility-panel__actions">
        ${togglesMarkup}
      </div>
      <div class="accessibility-panel__footer">
        <a class="accessibility-footer-button" href="${themeConfig.contactUrl || "#"}">${labels.report}</a>
        <a class="accessibility-footer-button" href="${themeConfig.accessibilityUrl || "#"}">${labels.statement}</a>
        <button class="accessibility-footer-button accessibility-footer-button--secondary" type="button">${labels.reset}</button>
      </div>
      <div class="accessibility-panel__brand">
        <img class="accessibility-panel__brand-image" src="${themeConfig.assets?.cloudflareLogo || ""}" alt="Cloudflare">
      </div>
      <p class="accessibility-panel__powered">${labels.poweredBy}</p>
    `;

    document.body.append(fab, backdrop, panel);

    const syncButtons = () => {
      panel.querySelectorAll("[data-a11y-toggle]").forEach((button) => {
        const key = button.getAttribute("data-a11y-toggle");
        const active = Boolean(state[key]);
        button.classList.toggle("is-active", active);
        const status = button.querySelector(".accessibility-toggle__status");
        if (status) {
          status.textContent = active ? labels.on : labels.off;
        }
        button.setAttribute("aria-pressed", String(active));
      });
    };

    const openPanel = () => {
      backdrop.hidden = false;
      panel.hidden = false;
      document.body.classList.add("has-overlay");
      fab.setAttribute("aria-expanded", "true");
      const closeButton = panel.querySelector(".accessibility-panel__close");
      if (closeButton) {
        closeButton.focus();
      }
    };

    const closePanel = () => {
      backdrop.hidden = true;
      panel.hidden = true;
      document.body.classList.remove("has-overlay");
      fab.setAttribute("aria-expanded", "false");
      fab.focus();
    };

    fab.addEventListener("click", () => {
      if (panel.hidden) {
        openPanel();
      } else {
        closePanel();
      }
    });

    panel.addEventListener("click", (event) => {
      const toggle = event.target.closest("[data-a11y-toggle]");
      if (toggle) {
        const key = toggle.getAttribute("data-a11y-toggle");
        if (key === "screenSmall") {
          state.screenLarge = false;
        }
        if (key === "screenLarge") {
          state.screenSmall = false;
        }
        state[key] = !state[key];
        applyState();
        saveState();
        syncButtons();
        return;
      }

      if (event.target.closest(".accessibility-reset") || event.target.closest(".accessibility-footer-button--secondary")) {
        options.forEach((option) => {
          state[option.key] = false;
        });
        applyState();
        saveState();
        syncButtons();
        return;
      }

      if (event.target.closest(".accessibility-panel__close")) {
        closePanel();
      }
    });

    backdrop.addEventListener("click", closePanel);

    document.addEventListener("click", (event) => {
      if (panel.hidden) {
        return;
      }
      if (!panel.contains(event.target) && !fab.contains(event.target)) {
        closePanel();
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !panel.hidden) {
        closePanel();
      }
    });

    syncButtons();
  };

  const createWhatsAppFab = () => {
    if (document.querySelector(".whatsapp-fab")) {
      return;
    }

    const link = document.createElement("a");
    link.className = "whatsapp-fab";
    link.href = whatsappHref;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    link.setAttribute("aria-label", labels.whatsappOpen);
    link.setAttribute("title", labels.whatsapp);
    link.innerHTML = `
      <span class="whatsapp-fab__icon" aria-hidden="true">
        <img src="${themeConfig.assets?.whatsappFab || ""}" alt="" class="whatsapp-fab__image">
      </span>
    `;

    document.body.append(link);
  };

  loadState();
  applyState();
  if (document.body) {
    createWidget();
    createWhatsAppFab();
  } else {
    document.addEventListener(
      "DOMContentLoaded",
      () => {
        createWidget();
        createWhatsAppFab();
      },
      { once: true }
    );
  }
})();
